atcBackground.$inject = ['$document'];

/* @ngInject */
function atcBackground($document) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            atcBackground: '@',
        }
    };
    return directive;

    function link(scope, element, attrs) {
        var color = scope.atcBackground[0] === '#' ? scope.atcBackground : '#' + scope.atcBackground;

        $document[0].body.style.backgroundColor = color;
    }
}

export default atcBackground;